import BaseService from "./BaseService";

/** A user's saved feedback on one model result. Mirrors the controller response. */
export interface ModelResultFeedback {
    id: string;
    audioMetadataId: string;
    classifierId: string;
    evaluationId?: string | null;
    agreed: boolean;
    note: string | null;
    submittedAt: string;
}

/** Payload sent when a user saves feedback. Mirrors SaveModelResultFeedbackRequest. */
export interface SaveModelResultFeedbackRequest {
    audioMetadataId: string;
    classifierId: string;
    /** Set when saved from an evaluation; omit/null from conversation details. */
    evaluationId?: string | null;
    agreed: boolean;
    note: string | null;
}

export class ModelResultFeedbackService extends BaseService {
    protected urlBase = "api/ModelResultFeedback";

    /** The current user's feedback for every model result on one interaction. */
    public async getForInteraction(
        audioMetadataId: string,
    ): Promise<ModelResultFeedback[]> {
        return this.get<ModelResultFeedback[]>(
            new URLSearchParams({ audioMetadataId }),
            "GetForInteraction",
        );
    }

    /** Creates or updates the current user's feedback for a single model result. */
    public async saveFeedback(
        request: SaveModelResultFeedbackRequest,
    ): Promise<ModelResultFeedback> {
        return this.post<ModelResultFeedback>(
            JSON.stringify(request),
            new URLSearchParams(),
            "SaveFeedback",
        );
    }

    /** Soft-deletes the current user's feedback row. */
    public async deleteFeedback(id: string): Promise<void> {
        await this.delete(new URLSearchParams({ id }), "DeleteFeedback");
    }
}
